import AdeptusCustodesDatasheets from '../Data/AC.json';
import AeldariDatasheets from '../Data/AE.json';
import AdeptusMechanicusDatasheets from '../Data/AdM.json';
import AdeptaSororitasDatasheets from '../Data/AS.json';
import AdeptusAstartesDatasheets from '../Data/SM_Adeptus Astartes.json';
import AgentsoftheImperiumDatasheets from '../Data/AoI.json';
import AstraMilitarumDatasheets from '../Data/AM.json';
import BlackTemplarsDatasheets from '../Data/SM_Black Templars.json';
import BloodAngelsDatasheets from '../Data/SM_Blood Angels.json';
import ChaosKnightsDatasheets from '../Data/QT.json';
import DarkAngelsDatasheets from '../Data/SM_Dark Angels.json';
import DeathGuardDatasheets from '../Data/DG.json';
import DeathwatchDatasheets from '../Data/SM_Deathwatch.json';
import DrukhariDatasheets from '../Data/DRU.json';
import GenestealerCultsDatasheets from '../Data/GC.json';
import GreyKnightsDatasheets from '../Data/GK.json';
import HereticAstartesDatasheets from '../Data/CSM.json';
import ImperialKnightsDatasheets from '../Data/QI.json';
import LegionesDaemonicaDatasheets from '../Data/CD.json';
import LeaguesofVotannDatasheets from '../Data/LoV.json';
import NecronsDatasheets from '../Data/NEC.json';
import OrksDatasheets from '../Data/ORK.json';
import SpaceWolvesDatasheets from '../Data/SM_Space Wolves.json';
import TauEmpireDatasheets from '../Data/TAU.json';
import TyranidsDatasheets from "../Data/TYR.json";
import ThousandSonsDatasheets from '../Data/TS.json';
import WorldEatersDatasheets from '../Data/WE.json';
import AdeptusTitanicusDatasheets from '../Data/TL.json';

const getMenuItems = () => {
    return [
        {
            menu: 'Adepta Sororitas',
            datasheets: AdeptaSororitasDatasheets,
        },
        {
            menu: 'Adeptus Custodes',
            datasheets: AdeptusCustodesDatasheets,
        },
        {
            menu: 'Adeptus Mechanicus',
            datasheets: AdeptusMechanicusDatasheets,
        },
        {
            menu: 'Adeptus Titanicus',
            datasheets: AdeptusTitanicusDatasheets,
        },
        {
            menu: 'Aeldari', 
            datasheets: AeldariDatasheets
        },
        {
            menu: 'Agents of the Imperium',
            datasheets: AgentsoftheImperiumDatasheets,
        },
        {
            menu: 'Astra Militarum',
            datasheets: AstraMilitarumDatasheets,
        },
        {
            menu: 'Black Templars',
            datasheets: BlackTemplarsDatasheets,
        },
        {
            menu: 'Blood Angels',
            datasheets: BloodAngelsDatasheets,
        },
        {
            menu: 'Chaos Daemons',
            datasheets: LegionesDaemonicaDatasheets,
        },
        {
            menu: 'Chaos Knights',
            datasheets: ChaosKnightsDatasheets,
        },
        {
            menu: 'Chaos Space Marines',
            datasheets: HereticAstartesDatasheets,
        },
        {
            menu: 'Dark Angels',
            datasheets: DarkAngelsDatasheets,
        },
        {
            menu: 'Death Guard',
            datasheets: DeathGuardDatasheets,
        },
        {
            menu: 'Deathwatch',
            datasheets: DeathwatchDatasheets,
        },
        {
            menu: 'Drukhari',
            datasheets: DrukhariDatasheets,
        },
        {
            menu: 'Genestealer Cults',
            datasheets: GenestealerCultsDatasheets,
        },
        {
            menu: 'Grey Knights',
            datasheets: GreyKnightsDatasheets,
        },
        {
            menu: 'Imperial Knights',
            datasheets: ImperialKnightsDatasheets,
        },
        {
            menu: 'Leagues of Votann',
            datasheets: LeaguesofVotannDatasheets,
        },
        {
            menu: 'Necrons', 
            datasheets: NecronsDatasheets
        },
        {
            menu: 'Orks', datasheets: OrksDatasheets
        },
        {
            menu: 'Space Marines',
            datasheets: AdeptusAstartesDatasheets,
        },
        {
            menu: 'Space Wolves',
            datasheets: SpaceWolvesDatasheets,
        },
        {
            menu: 'T’au Empire',
            datasheets: TauEmpireDatasheets,
        },
        {
            menu: 'Thousand Sons',
            datasheets: ThousandSonsDatasheets,
        },
        {
            menu: 'Tyranids',
            datasheets: TyranidsDatasheets,
        },
        {
            menu: 'World Eaters',
            datasheets: WorldEatersDatasheets,
        },
    ];
};

export default getMenuItems;
